import { IMIUIColumn } from "../../../reducer/General/_interfaces";
import { ISelectedFilters } from "../../../reducer/mappingFiles/_interfaces";

export const ce_group_level_2_label = 'CE Group Level 2';
export const ce_group_level_3_label = 'CE Group Level 3';
export const gl_account_label = 'GL Account';
export const gl_account_description_label = 'GL Account Description';
export const ce_group_level_1_label = 'CE Group Level 1';
export const created_by = 'Created By';
export const updated_by = 'Updated By';
export const updated_at = 'Updated At';
export const mix_label = 'Mix';

export const IKA_MAP_COLUMNS:IMIUIColumn[] = [
    {
        id: 'mix',
        label: mix_label,
        minWidth: '10%',
        align: 'left',
        group: ''
    },
    {
        id: 'ce_group_level_1',
        label: ce_group_level_1_label,
        minWidth: '10%',
        align: 'left',
        group: ''
    },
    {
        id: 'ce_group_level_2',
        label: ce_group_level_2_label,
        minWidth: '10%',
        align: 'left',
        group: ''
    },
    {
        id: 'ce_group_level_3',
        label: ce_group_level_3_label,
        minWidth: '10%',
        align: 'left',
        group: ''
    },
    {
        id: 'gl_account',
        label: gl_account_label,
        minWidth: '10%',
        align: 'left',
        group: ''
    },
    {
        id: 'gl_account_description',
        label: gl_account_description_label,
        minWidth: '10%',
        align: 'left',
        group: ''
    },
    {
        id: 'created_by',
        label: created_by,
        minWidth: '10%',
        align: 'left',
        group: ""
    },
    {
        id: 'updated_by',
        label: updated_by,
        minWidth: '10%',
        align: 'left',
        group: ""
    },
    {
        id: 'updated_at',
        label: updated_at,
        minWidth: '10%',
        align: 'left',
        group: ""
    },
    {
        id: 'action',
        label: '',
        minWidth: 50,
        align: 'right',
        group: "other"
        // format: (value) => value.toFixed(2),
    },
]


export const INITIAL_FILTERS:ISelectedFilters = {
        buyng_group_cust_name: null,
        cust_planning_level: null,
        cust_planning_level_name:  null,
        gkc: null,
        selected_country: null,
}